import React from "react";
import { Button, Menu, Row } from "antd";
import { ErrorDropdownIcon } from "../../../../assets/svg";
import "./styles.scss";

const ErrorOption = ({ style, errorBtnClickHandler }) => (
  <Menu.Item
    key="error"
    title="Error loading data!"
    value="error"
    style={style}
    className="unclickable-option menu-item"
  >
    <Row className="error-icon" justify="center" align="middle">
      <ErrorDropdownIcon color="#cb2e31" />
      <p
        style={{
          width: "100%",
          whiteSpace: "normal",
          lineHeight: "2rem",
          textAlign: "center",
          color: "black",
        }}
      >
        {" "}
        <div>Error loading data</div>
        <Button onMouseDown={errorBtnClickHandler} type="link">
          Try Again
        </Button>
      </p>
    </Row>
  </Menu.Item>
);

export default ErrorOption;
